module.exports = __webpack_public_path__ + "static/media/Ibutton.173482ed.svg";